document.querySelectorAll('.starRate a').forEach(function (el) {
	el.addEventListener('click', function (event) {
		document.querySelectorAll('.starRate li a b').forEach(function (bTag) {
			bTag.parentNode.removeChild(bTag)
		})
		el.childNodes[0].insertAdjacentHTML('afterend', '<b></b>')
		if (event.preventDefault) {
			event.preventDefault()
		}
		else {
			event.returnValue = false
		}
	})
})
